/* ==========================================================================
   filmbro-lt.js — behaviour for the Lifetime v2 page (lt-* sections).

   Three jobs, and nothing else:

     1. [data-lt-cta][data-action="scroll"]   smooth-scroll to the price block
     2. [data-lt-cta][data-action="checkout"] clear cart, add Lifetime, checkout
     3. [data-lt-sticky]                      show the bar once the price block
                                              has scrolled past

   Every button on the page is the same snippet (snippets/lt-cta.liquid) and
   carries its own data-action, so which buttons scroll and which one takes
   money is a theme-editor setting rather than something baked in here.

   A member who already owns Lifetime gets every button relabelled and
   pointed at their dashboard instead, so the page never asks someone to buy
   what they have already paid for. That check is window.fbPlan(), the same
   one the pricing page uses.

   The preview tiles are lp-tile and play via filmbro-lp.js. Nothing in this
   file touches them.
   ========================================================================== */
(function () {
  'use strict';

  var TARGET = '#lt-price';

  /* ── scroll ─────────────────────────────────────────────────────────────
     The header is sticky, so scrollIntoView lands the price block under it.
     Offset by the header's real height rather than a guessed number, because
     that height is a CSS value someone may change. */
  function scrollToPrice() {
    var el = document.querySelector(TARGET);
    if (!el) return false;
    var header = document.querySelector('.lt-hd');
    var offset = header ? header.getBoundingClientRect().height + 12 : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  /* ── wiring ─────────────────────────────────────────────────────────── */
  function wire(root) {
    var btns = (root || document).querySelectorAll('[data-lt-cta]');

    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.dataset.ltBound) return;
      btn.dataset.ltBound = '1';

      btn.addEventListener('click', function (e) {
        /* Owned state wins over everything: the href is already the dashboard
           and the label already says so, so let the browser follow it. */
        if (btn.dataset.owned === '1') return;

        if (btn.getAttribute('data-action') === 'checkout') {
          /* Without the helper the link still goes somewhere useful — its
             href is the pricing page — so only take over when we can finish
             the job. */
          if (typeof window.fbPlanCheckout !== 'function') return;
          e.preventDefault();
          var label = btn.querySelector('[data-lt-label]') || btn;
          window.fbPlanCheckout(label, Number(btn.getAttribute('data-variant')), null);
          return;
        }

        /* Default: scroll. If the price block is not on this page the href
           stays a real link to it, so the click still works. */
        if (scrollToPrice()) e.preventDefault();
      });
    });

    /* Relabel for someone who already owns Lifetime. */
    if (typeof window.fbPlan === 'function') {
      window.fbPlan().then(function (plan) {
        if (plan !== 'lifetime') return;
        Array.prototype.forEach.call(btns, function (btn) {
          var owned = btn.getAttribute('data-owned-label');
          var url = btn.getAttribute('data-owned-url') || '/pages/dashboard';
          if (!owned) return;
          var label = btn.querySelector('[data-lt-label]');
          if (label) label.textContent = owned;
          btn.setAttribute('href', url);
          btn.dataset.owned = '1';
        });
      }).catch(function () { /* not signed in, or the lookup failed: leave the buy state */ });
    }
  }

  /* ── sticky bar ─────────────────────────────────────────────────────────
     Shows once the HERO is above the viewport, not the price block. The hero
     already carries a buy button, so the bar would only duplicate it while
     the hero is on screen; the moment it scrolls away there is nothing to
     buy with until the price block, which is most of the page.

     Falls back to the price block if the hero is not on the page, so the bar
     still behaves on a layout built without it. IntersectionObserver rather
     than a scroll listener: no work on a scroll that changes nothing. */
  var _stickyObs = null;
  function sticky() {
    var bar = document.querySelector('[data-lt-sticky]');
    var anchor = document.querySelector('.lt-hero') || document.querySelector(TARGET);
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    /* The editor calls this again on every section reload, so drop the old
       observer first rather than stacking one per edit. */
    if (_stickyObs) _stickyObs.disconnect();

    _stickyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    }, { threshold: 0 });
    _stickyObs.observe(anchor);
  }

  function init() { wire(document); sticky(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor re-renders one section at a time; rebind that section. */
  document.addEventListener('shopify:section:load', function (e) {
    wire(e.target);
    sticky();
  });
})();
